import { render, staticRenderFns } from "./quotaTable.vue?vue&type=template&id=0a9d201b&scoped=true&"
import script from "./quotaTable.vue?vue&type=script&lang=js&"
export * from "./quotaTable.vue?vue&type=script&lang=js&"
import style0 from "./quotaTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9d201b",
  null
  
)

export default component.exports